import styled, { css } from "styled-components";


const Wrap = styled.div`

`;
export default function DialChart({value, color="green", ...props}) {
    const tick = Math.floor(value / 2);
    return (
        <Wrap className="dial-chart" data-color={color}>
            <div className="idx start">0</div>
            <div className="idx middle">50</div>
            <div className="idx end">100</div>

            <div className="value">
                <span>{value}</span>%
            </div>

            <div className="dial">
                {Array(50)
                    .fill(0)
                    .map((val, idx) => {
                        return <div className={`tick${idx == tick ? " active" : ""}${idx <= tick ? " fill" : ""}${(idx) % 25 == 0 || idx == 0 ? " point" : ""}`} key={idx} data-idx={idx + 1}></div>;
                    })}
            </div>
        </Wrap>
    );
}